export enum MY_FORM_STATUS {
   PENDING = 'PENDING',
   COMPLETED = 'COMPLETED',
   CANCELLED = 'CANCELLED',
  }

  const MY_FORM_STATUS_TRANSLATION = {
    [MY_FORM_STATUS.PENDING]: 'PENDING',
    [MY_FORM_STATUS.COMPLETED]: 'COMPLETED',
    [MY_FORM_STATUS.CANCELLED]: 'CANCELLED',
};

export const getMyFormStatusTranslationKey = (key: MY_FORM_STATUS) => {
  return MY_FORM_STATUS_TRANSLATION[key];
};
